<template>
    <div class="audit-equipment-response-badge">
        <b-badge v-if="show" :variant="variant">{{ text }}</b-badge>
    </div>
</template>

<script>

export default {
    name: 'AuditEquipmentResponseBadge',
    props: {
        auditEquipment: Object,
    },
    computed: {
        variant () {
            if (this.auditEquipment.responseStatus) {
                if (this.auditEquipment.responseStatus === 'AWAITING') {
                    return 'warning'
                } else if (this.auditEquipment.responseStatus === 'RESPONDED') {
                    return 'success'
                } else if (this.auditEquipment.responseStatus === 'LATE') {
                    return 'danger'
                } else if (this.auditEquipment.responseStatus === 'NO_FOLLOW_UP') {
                    return 'warning'
                }
            }
            return ''
        },
        text () {
            return this.auditEquipment.responseStatus.replaceAll('_', ' ')
        },
        show () {
            return this.auditEquipment &&
                this.auditEquipment.status &&
                (this.auditEquipment.status === 'ISSUE' || this.auditEquipment.status === 'VIOLATION')
        }
    }
}
</script>

<style scoped>

</style>
